<template>
  <CustomModal
    :value="show"
    is-centered
    width="740px"
    icon="fa-search"
    cancel-text="Cerrar"
    :show-save="false"
    show-top-close
    fit-height-content
    title="Detalle de Visitas"
    @cancel="cancel"
  >
    <div v-for="(item, itemIdx) in detailItems" :key="itemIdx">
      <div
        v-if="
          itemIdx >= (pagination.currentPage - 1) * pageSize &&
            itemIdx < pagination.currentPage * pageSize
        "
        class="gray-box mt-1"
      >
        <div class="col-12 px-4 py-2 d-flex">
          <div v-if="!hideType" class="col-3 p-0">
            <div class="d-flex flex-column">
              <span class="data-title">Tipo:</span>
              <span class="data-content">{{ item.visitTypeName }}</span>
            </div>
          </div>
          <div class="p-0" :class="{ 'col-6': hideType, 'col-4': !hideType }">
            <div class="d-flex flex-column">
              <span class="data-title">Fecha:</span>
              <span class="data-content">{{ item.visitDateFormat }}</span>
            </div>
          </div>
          <div class="p-0" :class="{ 'col-6': hideType, 'col-5': !hideType }">
            <div class="d-flex flex-column">
              <span class="data-title">Horario:</span>
              <span class="data-content">
                {{ getTime1(item.completeTime) }}
                <b>{{ getTime2(item.completeTime) }}</b>
              </span>
              <span
                v-if="
                  serviceTypeId == rpServiceTypes.AsistenteServiciosEnfermera
                "
                class="data-content"
              >
                {{ getTime1(item.completeTimeContinued) }}
                <span class="bold">
                  {{ getTime2(item.completeTimeContinued) }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Pagination
      id="pgVisitDetailHistory"
      :show-text="false"
      :data="pagination"
      @pagination-go-page="goToPage"
    />
  </CustomModal>
</template>

<script>
import CustomModal from '@/components/common/CustomModal.vue';
import Pagination from '@/components/common/Pagination.vue';
import RpServiceTypes from '@/utils/constants/rp/rpServiceTypes.js';

export default {
  name: 'VisitDetailsHistory',
  props: {
    hideType: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      show: false,
      pageSize: 6,
      admissionId: null,
      serviceTypeId: 0,
      pagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
      },
      detailItems: null,
      visits: [],
      rpServiceTypes: RpServiceTypes,
    };
  },
  components: {
    CustomModal,
    Pagination,
  },
  computed: {},
  methods: {
    getTime1(timeString) {
      if (timeString != undefined)
        return (
          timeString
            .substring(0, timeString.indexOf('('))
            .toLowerCase()
            .replace('.', '') + ' '
        );
    },
    getTime2(timeString) {
      if (timeString != undefined)
        return timeString.substring(timeString.indexOf('('), timeString.length);
    },
    goToPage(page) {
      this.pagination.currentPage = page;
    },
    open(id, visits, serviceTypeId) {
      if (id || (visits && visits.length > 0)) {
        this.admissionId = id;
        this.visits = visits;
        this.serviceTypeId = serviceTypeId;
        let self = this;
        self.getVisitHistory().then(function() {
          self.show = true;
        });
      }
    },
    async getVisitHistory() {
      let self = this;

      let promise = new Promise((resolve) => {
        if (self.admissionId) {
          self
            .$ApiGet(
              '/api/thrpyadmission/GetAdmissionVisitDetail/' + self.admissionId
            )
            .then((res) => {
              self.detailItems = res.data;
              self.pagination.totalItemCount = self.detailItems.length;
              self.pagination.pageCount = Math.ceil(
                self.pagination.totalItemCount / self.pageSize
              );
              resolve(res.data);
            })
            .catch((err) => {
              self.response = err;
            });
        } else {
          self.detailItems = self.visits;
          self.pagination.totalItemCount = self.detailItems.length;
          self.pagination.pageCount = Math.ceil(
            self.pagination.totalItemCount / self.pageSize
          );
          resolve(self.visits);
        }
      });
      return promise;
    },
    async cancel() {
      this.show = false;
      this.pagination = {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
      };
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.gray-box {
  border-radius: 5px;
  background-color: #f7f7f7;
}
</style>
